import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import localeRo from '@angular/common/locales/ro';
import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { environment } from '../environments/environment';
import { gitVersions } from '../environments/versions';
import { routes } from './app.routes';
import { AuthService } from './shared/services/auth.service';
import { jwtInterceptor } from './shared/interceptors/jwt.interceptor';
import { loadingInterceptor } from './shared/interceptors/loading.interceptor';
import { provideShared } from './shared/providers/shared.providers';

// al treilea argument e pastrat identic cu vechiul AppModule
registerLocaleData(localeRo, 'ro', localeRo);

// Sentry pornește doar pe mediile care au configurare (test și prod)
// tipul e declarat explicit: pe mediile fără Sentry valoarea e null
const sentry = environment.sentry as { dsn: string; environment: string } | null;
if (sentry) {
    Sentry.init({
        dsn: sentry.dsn,
        environment: sentry.environment,
        release: `${gitVersions.version}+${gitVersions.revision}`,
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        tracePropagationTargets: ['localhost', 'https://rm.cmr.ro', 'https://rm.cmr.comprami.ro'],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.1,
    });
}

const sentryProviders = sentry
    ? [
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
        { provide: Sentry.TraceService, deps: [Router] },
        provideAppInitializer(() => {
            inject(Sentry.TraceService);
        }),
    ]
    : [];

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withXhr(), withInterceptors([loadingInterceptor, jwtInterceptor])),
        ...provideShared(),
        // refacerea sesiunii după F5, înainte de prima navigare (guard-urile văd sesiunea)
        provideAppInitializer(() => inject(AuthService).reiaSesiunea()),
        ...sentryProviders,
    ],
};
